import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import NeverBox from './NeverBox';

// Modal « photo, titre et description »: the design of the former « site de commande » modal of
// the menu page, used by every pop-up except the double authentification one.
// ImageTexteContenu is the inside of the modal, also shown as the live preview in /admin-popups.
// contact (cta_action « contact », PopupHost): { etat: 'envoi' | 'envoye' | 'erreur', erreur }
//   envoi : main button « Envoi en cours… », buttons locked
//   envoye: the modal shows the confirmation, « Continuer » goes on (onClose)
//   erreur: the message in the modal, the main button sends again

const buttonStyle = (color) => ({
  backgroundColor: color,
  borderColor: color,
  color: 'white',
  padding: '0.5rem 1.5rem',
  borderRadius: '6px',
  fontWeight: '500',
});

function ContactEnvoye({ sujet, onContinue }) {
  return (
    <>
      <ModalHeader toggle={onContinue} />
      <ModalBody style={{ padding: '2.5rem 1.5rem 2rem', textAlign: 'center' }}>
        <CheckCircleFilled style={{ fontSize: 64, color: '#16a34a' }} />
        <h4 style={{ margin: '1.25rem 0 0.5rem', color: '#1f2937', fontWeight: 600 }}>Demande envoyée !</h4>
        <p style={{ color: '#64748b', margin: '0 auto', maxWidth: 420, lineHeight: 1.6 }}>
          Merci, notre équipe a bien reçu votre demande{sujet ? <> au sujet de « {sujet} »</> : null} et vous contactera très
          bientôt.
        </p>
      </ModalBody>
      <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '1rem 1.5rem', justifyContent: 'center' }}>
        <Button color="success" onClick={onContinue} style={buttonStyle('#16a34a')} autoFocus>
          Continuer
        </Button>
      </ModalFooter>
    </>
  );
}

export function ImageTexteContenu({ popup, text, onDone, onLater, onClose, never, setNever, contact }) {
  const etat = contact && contact.etat;
  if (etat === 'envoye') return <ContactEnvoye sujet={text.titre} onContinue={onClose} />;
  const envoi = etat === 'envoi';
  // contact without a button text: the one of « site de commande »
  const cta = text.cta || (popup.cta_action === 'contact' ? 'Je souhaite être contacté' : '');
  return (
    <>
      <ModalHeader toggle={envoi ? undefined : onClose} />
      <ModalBody style={{ padding: '0' }}>
        {popup.image && (
          <div style={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
            <img src={popup.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          </div>
        )}
        <div style={{ padding: '1.5rem' }} dir={text.rtl ? 'rtl' : 'ltr'}>
          {text.titre && <h4 style={{ marginBottom: '1rem', color: '#1f2937', fontWeight: '600' }}>{text.titre}</h4>}
          {text.texte && (
            <p style={{ color: '#64748b', marginBottom: '1.5rem', lineHeight: '1.6', whiteSpace: 'pre-line' }}>{text.texte}</p>
          )}
          <NeverBox show={popup.peut_masquer} checked={never} onChange={setNever} style={{ textAlign: 'start', marginTop: 0 }} />
          {etat === 'erreur' && (
            <div
              role="alert"
              style={{
                display: 'flex',
                gap: 10,
                alignItems: 'flex-start',
                marginTop: '1rem',
                padding: '0.75rem 1rem',
                borderRadius: 8,
                background: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#b91c1c',
              }}
            >
              <ExclamationCircleFilled style={{ fontSize: 18, marginTop: 2 }} />
              <span>{contact.erreur || "L'envoi de votre demande a échoué. Réessayez dans un instant."}</span>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter
        style={{
          borderTop: '1px solid #e5e7eb',
          padding: '1rem 1.5rem',
          display: 'flex',
          justifyContent: cta ? 'space-between' : 'flex-end',
          gap: '1rem',
        }}
      >
        <Button color="secondary" onClick={onLater} disabled={envoi} style={buttonStyle('#6b7280')}>
          {text.plus_tard || (cta ? 'Plus tard' : 'Fermer')}
        </Button>
        {cta && (
          <Button color="primary" onClick={onDone} disabled={envoi} style={buttonStyle('#ff7171')}>
            {envoi ? (
              <>
                <Spinner size="sm" style={{ marginInlineEnd: 8 }} /> Envoi en cours…
              </>
            ) : etat === 'erreur' ? (
              'Réessayer'
            ) : (
              cta
            )}
          </Button>
        )}
      </ModalFooter>
    </>
  );
}

export default function ImageTexte(props) {
  return (
    <Modal
      isOpen={props.open}
      toggle={props.contact && props.contact.etat === 'envoi' ? undefined : props.onClose}
      backdrop={props.contact && props.contact.etat === 'envoi' ? 'static' : true}
      size="lg"
      centered
      zIndex={props.zIndex}
    >
      <ImageTexteContenu {...props} />
    </Modal>
  );
}
